<template>
    <div class="
        container container--grid mt-24 mb-24
        md:mt-28 md:mb-28
        xxl:mb-48 xxl:mt-56
    ">
        <div class="
            flex flex-col justify-between col-span-4
            sm:col-span-10 sm:col-start-2
        ">
            <div>
                <div class="
                    flex flex-wrap items-center border-cream border-t border-b pt-7 pb-1
                    sm:border-none sm:pt-0 sm:pb-0
                    md:mb-6
                    xxl:mb-14
                ">
                    <p class="hidden w-full text-13 mb-4 sm:block xxl:text-20 xxl:w-36">About</p>
                    <div
                        class="
                            cursor-pointer underline decoration-1 underline-offset-2 text-24 mb-6 mr-6 hover:text-black
                            sm:text-20 sm:mb-4
                            md:text-28
                            xxl:mr-14 xxl:text-30
                        "
                        :class="{'text-black' : curAbout === 'all', 'text-blue' : curAbout !== 'all'}"
                        @click="curAbout = 'all'"
                    >
                        All
                    </div>
                    <div
                        class="
                            cursor-pointer underline decoration-1 underline-offset-2 text-24 mb-6 mr-6 hover:text-black
                            sm:text-20 sm:mb-4
                            md:text-28
                            xxl:mr-14 xxl:text-30
                        "
                        :class="{'text-black' : item.slug === curAbout, 'text-blue' : item.slug !== curAbout}"
                        v-for="item in about"
                        :key="item.slug"
                        @click="curAbout = item.slug, current = 1"
                    >
                        {{ item.name }}
                    </div>
                </div>
                <div class="
                    flex flex-wrap items-center border-cream border-b pt-7 pb-1
                    sm:border-none sm:pt-0 sm:pb-0
                ">
                    <p class="hidden w-full text-13 mb-4 sm:block xxl:text-20 xxl:w-36 xxl:mb-8">Type</p>
                    <div
                        class="
                            cursor-pointer label label--blue mb-6 mr-6 
                            sm:mr-1
                            md:mr-3.5
                            xxl:mb-8 xxl:mr-2
                            hover:opacity-100
                        "
                        :class="{'opacity-100' : curType === 'all', 'opacity-25' : curType !== 'all'}"
                        @click="curType = 'all', current = 1"
                    >
                        All
                    </div>
                    <div
                        v-show="type.slug !== 'dojo'"
                        class="
                            cursor-pointer label mb-6 mr-6
                            sm:mr-1
                            md:mr-3.5
                            xxl:mb-8 xxl:mr-2
                            hover:opacity-100
                        "
                        :class="{
                            'label--yellow' : type.slug === 'dojo',
                            'label--blue' : type.slug !== 'dojo',
                            'opacity-100' : type.slug === curType && type.slug === 'all',
                            'opacity-25' : type.slug !== curType && curType !== 'all',
                        }"
                        v-for="type in types"
                        :key="type.slug"
                        @click="curType = type.slug, current = 1"
                    >
                        {{ type.name }}
                    </div>
                </div>
            </div>
        </div>
        <newsPosts :posts="printedPosts"></newsPosts>
        
        <span v-show="postsList.length > curLastIndex"
              @click="loadMore"
              class="mt-10 col-span-4 mx-auto cursor-pointer link | sm:col-span-12 sm:mt-12 | md:mt-20 | lg:mt-24"
        >
            load more
        </span>
    </div>
</template>

<script>
import newsPosts from './partials/news-posts.vue';
export default {
    data() {
        return {
            perPage: parseInt(this.postsPerPage),
            lastItem: parseInt(this.postsPerPage),
            posts: this.json,
            step: parseInt(this.loadStep),
            curType: 'all',
            curAbout: 'all',
            curLastIndex: this.perPage,
            current: 1,
        }
    },
    props: {
        json: [Object, Array],
        postsPerPage: [Number, String],
        loadStep: [Number, String],
        types: [Object, Array],
        about: [Object, Array]
    },
    computed: {
        postsList() {
            let posts = this.posts;
            this.curLastIndex = this.perPage;
            
            // Filter types
            posts = posts.filter(post => {
                if (this.curType !== 'all') {
                    if ( post.types ) {
                        return post.types.some(type => type.slug === this.curType)
                    }
                } else {
                    return post;
                }
            });
            // Filter about
            posts = posts.filter(post => {
                if (this.curAbout !== 'all') {
                    if ( post.about ) {
                        return post.about.some(item => item.slug === this.curAbout)
                    }
                } else {
                    return post;
                }
            });
            // Return posts with all filters and sorted
            return posts;
        },
        printedPosts() {
            return this.postsList.slice(0, this.curLastIndex);
        },
    },
    methods: {
        loadMore() {
            this.curLastIndex += this.step;
        },
    },
    components: {
        newsPosts
    },
}
</script>

<style lang="scss">
</style>